module.exports = __webpack_public_path__ + "img/motorway_11x1_z16.8fad978e.svg";